import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../axios/axiosInstance';
import { useShowAlert } from '../../../hooks/useShowAlert';
import { normalizePhoneNumber } from '../../../helper/normalizePhoneNumber';
const useSendTokenToContact = () => {
  const { showAlert } = useShowAlert();
  const navigate = useNavigate();

  // Send token to email. `silent: true` is for an already-authenticated
  // caller (e.g. Account info's inline add/verify-email step) that shows
  // its own code-entry UI in place rather than navigating to the
  // Guest-only /verification route -- that route redirects a logged-in
  // user straight back to /profile before they ever see it.
  const sendTokenToEmail = async (email, { silent = false } = {}) => {
    try {
      await axiosInstance.post("/user/generate-email-token", { email });
      showAlert("success", "OTP sent successfully.");
      if (!silent) navigate(`/verification/email/${email}`);
      return true;
    } catch (err) {
      showAlert("error", err.response?.data?.error);
      // A 429 cooldown means a code from a recent request is probably
      // already on its way -- still let the caller show the code-entry
      // step rather than dead-ending the flow.
      return err.response?.status === 429;
    }
  };

  // Send token to phone number
  const sendTokenToPhoneNumber = async (phoneNumber, channel = "sms") => {
    const normalizedPhoneNumber = normalizePhoneNumber("", phoneNumber);

    try {
      await axiosInstance.post("/user/generate-phone-token", { phoneNumber: normalizedPhoneNumber, channel });
      localStorage.setItem("otpChannel", channel);
      showAlert("success", channel === "whatsapp" ? "Verification code sent via WhatsApp." : "Verification code sent.");
      navigate(`/verification/phone/${normalizedPhoneNumber}`);
    } catch (err) {
      showAlert("error", err.response?.data?.error || "We could not send the verification code.");
    }
  };

  return { sendTokenToEmail, sendTokenToPhoneNumber };
};

export default useSendTokenToContact;
